(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Inspire-Brand-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function setToggleState(toggle, playing) {
    if (!toggle) return;
    var text = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
    var label = toggle.querySelector('[data-inspire-video-toggle-label]');
    toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
    toggle.setAttribute('aria-label', text);
    if (label) label.textContent = text;
  }

  function initHeroVideo(video) {
    if (video.dataset.inspireReady === 'true') return;
    video.dataset.inspireReady = 'true';

    var root = video.closest('[data-inspire-root]');
    var toggle = root ? root.querySelector('[data-inspire-video-toggle]') : null;

    // iOS weigert autoplay tenzij muted en playsInline als PROPERTY gezet zijn;
    // alleen het HTML-attribuut is niet in alle versies genoeg.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');

    // Precies één bron laden, afhankelijk van de viewport.
    function pickSource() {
      var wanted = mobileQuery.matches ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (!wanted || video.dataset.currentSrc === wanted) return false;
      video.dataset.currentSrc = wanted;
      video.src = wanted;
      video.load();
      return true;
    }

    function attemptPlay() {
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Autoplay geblokkeerd, bijvoorbeeld door Low Power Mode of
          // databesparing. Toon de knop als 'speel video'.
          setToggleState(toggle, false);
        });
      }
    }

    function play() {
      var switched = pickSource();
      if (switched && video.readyState < 2) {
        // Direct na load() is er nog geen data: wachten op canplay, anders
        // faalt play() stil en blijft het vlak leeg.
        video.addEventListener('canplay', attemptPlay, { once: true });
        return;
      }
      attemptPlay();
    }

    video.addEventListener('playing', function () {
      video.setAttribute('data-inspire-video-active', '');
      setToggleState(toggle, true);
    });

    video.addEventListener('pause', function () {
      setToggleState(toggle, false);
    });

    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (video.paused) {
          video.dataset.inspirePaused = 'false';
          play();
        } else {
          // Handmatig gepauzeerd: niet opnieuw starten als de hero weer in
          // beeld komt.
          video.dataset.inspirePaused = 'true';
          video.pause();
        }
      });
    }

    // De video niet meteen starten: dat concurreert met het LCP-beeld van de
    // hero. Wachten op 'load' en daarna alleen spelen zolang de hero in beeld
    // is, zodat er onderaan de pagina geen video door blijft lopen.
    function observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!motionQuery.matches && video.dataset.inspirePaused !== 'true') play();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(video);
    }

    if (motionQuery.matches) {
      // Geen beweging: bron alleen laden als de bezoeker zelf op play drukt.
      setToggleState(toggle, false);
    } else if (document.readyState === 'complete') {
      observeVisibility();
    } else {
      window.addEventListener('load', observeVisibility, { once: true });
    }

    motionQuery.addEventListener('change', function (event) {
      if (event.matches) {
        video.pause();
      } else if (video.dataset.inspirePaused !== 'true') {
        play();
      }
    });

    mobileQuery.addEventListener('change', function () {
      if (!video.paused) play();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-inspire-hero-video]').forEach(initHeroVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Nrg-fitshop-partnership"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nrg-fitshop-partnership')) {
    customElements.define('nrg-fitshop-partnership', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a[data-map-link]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(this.dataset.mapId);
          if (!target) return;
          event.preventDefault();
          const offset = Number(this.dataset.scrollOffset) || 0;
          const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
          window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          const heading = target.querySelector('h2');
          if (heading) {
            const originalTabindex = heading.getAttribute('tabindex');
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
            heading.addEventListener('blur', () => {
              if (originalTabindex === null) heading.removeAttribute('tabindex');
              else heading.setAttribute('tabindex', originalTabindex);
            }, { once: true });
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centr-brand-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('centr-brand-film')) {
    customElements.define('centr-brand-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;

        this.video = this.querySelector('video');
        this.control = this.querySelector('button');

        if (!this.video || !this.control || !this.dataset.desktop) return;

        this.abort = new AbortController();

        const options = { signal: this.abort.signal };

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.connection = navigator.connection;
        this.visible = false;
        this.manual = null;
        this.failed = false;
        this.requested = false;
        this.control.hidden = false;
        this.label = this.control.querySelector('.centr-film__label');
        this.symbol = this.control.querySelector('.centr-film__symbol');

        this.control.addEventListener('click', () => {
          this.manual = !this.requested;
          this.sync();
        }, options);

        this.video.addEventListener('loadedmetadata', () => {
          const duration = this.video.duration;

          this.start = Math.min(
            Math.max(Number(this.dataset.start) || 0, 0),
            Math.max(duration - .5, 0)
          );

          const end = Number(this.dataset.end) || 0;

          this.end = end > this.start
            ? Math.min(end, duration)
            : duration;

          if (this.start > 0) {
            this.video.currentTime = this.start;
          }
        }, options);

        this.video.addEventListener('timeupdate', () => {
          if (this.end && this.video.currentTime >= this.end - .12) {
            this.video.currentTime = this.start || 0;
          }
        }, options);

        this.video.addEventListener('playing', () => {
          if (!this.requested) {
            this.video.pause();
            return;
          }

          this.classList.add('has-frame');
          this.updateButton(true);
        }, options);

        this.video.addEventListener('pause', () => {
          this.updateButton(false);
        }, options);

        this.video.addEventListener('error', () => {
          this.failed = true;
          this.requested = false;
          this.classList.remove('has-frame');
          this.control.hidden = true;
        }, options);

        this.motion.addEventListener('change', () => {
          this.manual = null;
          this.sync();
        }, options);

        this.mobile.addEventListener('change', () => this.sync(), options);
        this.connection?.addEventListener('change', () => this.sync(), options);

        document.addEventListener(
          'visibilitychange',
          () => this.sync(),
          options
        );

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible =
              entries[0].isIntersecting &&
              entries[0].intersectionRatio >= .1;

            this.sync();
          }, { threshold: [0, .1] });

          this.observer.observe(this);
        } else {
          this.visible = true;
          this.sync();
        }
      }

      updateButton(playing) {
        this.label.textContent = playing
          ? this.dataset.pause
          : this.dataset.play;

        this.symbol.textContent = playing ? 'Ⅱ' : '▶';
      }

      sync() {
        if (!this.video || this.failed) return;

        const automatic =
          this.dataset.autoplay === 'true' &&
          !this.motion.matches &&
          !this.connection?.saveData;

        const intent = this.manual === null
          ? automatic
          : this.manual;

        this.requested = intent && this.visible && !document.hidden;

        if (!this.requested) {
          this.video.pause();
          return;
        }

        const source = this.mobile.matches
          ? this.dataset.mobile || this.dataset.desktop
          : this.dataset.desktop;

        if (this.currentSource !== source) {
          this.classList.remove('has-frame');
          this.currentSource = source;
          this.start = 0;
          this.end = 0;
          this.video.src = source;
          this.video.muted = true;
          this.video.load();
        }

        if (!this.video.paused) return;

        this.video.play().catch(error => {
          if (error.name === 'AbortError' || !this.isConnected) return;

          this.manual = false;
          this.requested = false;
          this.updateButton(false);
        });
      }

      disconnectedCallback() {
        this.requested = false;
        this.video?.pause();
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centr-hyrox-brand-race"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nrg-centr-race')) {
    customElements.define('nrg-centr-race', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const controller = new AbortController();
        const signal = controller.signal;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = window.matchMedia('(max-width: 749px)');
        const panels = [];
        const canAutoplay = () => this.dataset.autoplay === 'true' && !motion.matches && !navigator.connection?.saveData && (!mobile.matches || this.dataset.mobileAutoplay === 'true');
        const sync = (state) => {
          const playing = state.video && !state.video.paused;
          state.button.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          state.video?.classList.toggle('is-playing', Boolean(playing));
        };
        const mount = (state) => {
          if (state.video) return;
          state.template.parentNode.appendChild(state.template.content.cloneNode(true));
          state.video = state.template.parentNode.querySelector('video');
          if (!state.video) return;
          state.video.muted = true;
          state.video.defaultMuted = true;
          state.video.playsInline = true;
          ['playing', 'pause', 'ended', 'error'].forEach(type => state.video.addEventListener(type, () => sync(state), { signal }));
        };
        const play = (state) => {
          mount(state);
          if (!state.video) return;
          state.video.play().catch(() => sync(state));
        };
        const update = (state) => {
          if (!state.visible || document.hidden) { state.video?.pause(); return; }
          if (state.choice === 'play' || (state.choice === null && canAutoplay())) play(state);
          else state.video?.pause();
        };
        this.querySelectorAll('[data-video-panel]').forEach(panel => {
          const template = panel.querySelector('[data-video-template]');
          const button = panel.querySelector('[data-video-toggle]');
          if (!template || !button) return;
          const state = { panel, template, button, video: null, visible: false, choice: null };
          panels.push(state);
          button.hidden = false;
          button.addEventListener('click', () => {
            state.choice = state.video && !state.video.paused ? 'pause' : 'play';
            state.visible = true;
            update(state);
          }, { signal });
        });
        const mediaObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const state = panels.find(item => item.panel === entry.target);
            if (state) { state.visible = entry.isIntersecting; update(state); }
          });
        }, { threshold: .1 }) : null;
        panels.forEach(state => mediaObserver?.observe(state.panel));
        const visibility = () => panels.forEach(update);
        const preference = () => {
          panels.forEach(state => { state.choice = null; update(state); });
        };
        document.addEventListener('visibilitychange', visibility, { signal });
        motion.addEventListener('change', preference, { signal });
        mobile.addEventListener('change', visibility, { signal });
        const stations = Array.from(this.querySelectorAll('[data-station]'));
        const links = Array.from(this.querySelectorAll('[data-station-link]'));
        const progress = this.querySelector('[data-race-progress]');
        const stationObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          const entry = entries.filter(item => item.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!entry) return;
          const index = stations.indexOf(entry.target);
          links.forEach((link,i) => i === index ? link.setAttribute('aria-current','step') : link.removeAttribute('aria-current'));
          if (progress) progress.style.setProperty('--chx-progress', `${(index + 1) / stations.length * 100}%`);
        }, { rootMargin: '-10% 0px -40% 0px', threshold: 0 }) : null;
        stations.forEach(station => stationObserver?.observe(station));
        this.cleanup = () => {
          controller.abort();
          mediaObserver?.disconnect();
          stationObserver?.disconnect();
          panels.forEach(state => { state.video?.pause(); state.video?.remove(); });
        };
      }
      disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liveness-brand-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function setToggleState(toggle, playing) {
    if (!toggle) return;
    var text = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
    var label = toggle.querySelector('[data-liveness-video-toggle-label]');
    toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
    toggle.setAttribute('aria-label', text);
    if (label) label.textContent = text;
  }

  function initHeroVideo(video) {
    if (video.dataset.livenessReady === 'true') return;
    video.dataset.livenessReady = 'true';

    var root = video.closest('[data-liveness-root]');
    var toggle = root ? root.querySelector('[data-liveness-video-toggle]') : null;

    // iOS weigert autoplay tenzij muted en playsInline als PROPERTY gezet zijn;
    // alleen het HTML-attribuut is niet in alle versies genoeg.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');

    // Precies één bron laden, afhankelijk van de viewport.
    function pickSource() {
      var wanted = mobileQuery.matches ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (!wanted || video.dataset.currentSrc === wanted) return false;
      video.dataset.currentSrc = wanted;
      video.src = wanted;
      video.load();
      return true;
    }

    function attemptPlay() {
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Autoplay geblokkeerd (bijv. iOS Low Power Mode of databesparing).
          // Toon de knop als 'speel video' zodat de bezoeker zelf kan starten.
          setToggleState(toggle, false);
        });
      }
    }

    function play() {
      var switched = pickSource();
      if (switched && video.readyState < 2) {
        // Direct na load() is er nog geen data: wachten op canplay, anders
        // faalt play() stil en blijft de video zwart.
        video.addEventListener('canplay', attemptPlay, { once: true });
        return;
      }
      attemptPlay();
    }

    function pause() {
      video.pause();
    }

    // Het attribuut volgt de echte staat van het element, niet onze intentie.
    video.addEventListener('playing', function () {
      video.setAttribute('data-liveness-video-active', '');
      setToggleState(toggle, true);
    });

    video.addEventListener('pause', function () {
      setToggleState(toggle, false);
    });

    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (video.paused) {
          play();
        } else {
          pause();
        }
      });
    }

    if (motionQuery.matches) {
      // Geen beweging: bron alleen laden als de bezoeker zelf op play drukt.
      setToggleState(toggle, false);
    } else {
      play();
    }

    motionQuery.addEventListener('change', function (event) {
      if (event.matches) {
        pause();
      } else {
        play();
      }
    });

    mobileQuery.addEventListener('change', function () {
      if (!video.paused) play();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-liveness-hero-video]').forEach(initHeroVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrg-fitwinkel-case-nl"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nrg-fitwinkel')) {
    customElements.define('nrg-fitwinkel', class extends HTMLElement {
      connectedCallback() {
        this.onAnchorClick = (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
          window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - padding, behavior: 'instant' });
          history.pushState(null, '', link.hash);
          const focusTarget = target.querySelector('h2, h3, input, button, a') || target;
          const previousTabindex = focusTarget.getAttribute('tabindex');
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
          focusTarget.addEventListener('blur', () => {
            if (previousTabindex === null) focusTarget.removeAttribute('tabindex');
            else focusTarget.setAttribute('tabindex', previousTabindex);
          }, { once: true });
        };
        this.addEventListener('click', this.onAnchorClick);
        this.onBlockSelect = (event) => {
          const detail = event.target.closest('details');
          if (detail && this.contains(detail)) detail.open = true;
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onAnchorClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrg-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrg-retailer-partner-focus"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var QUOTE_YES = 'Ja';
      var QUOTE_NO = 'Nee';


/*
   Offertekeuze: bij 'Ja' verdwijnt het verkoopkanaal en verschijnt op die 
   plek het veld voor SKU/EAN of productsoorten. Bedrijfsnaam wordt dan 
   optioneel, zodat ook klanten zonder bedrijf een offerte kunnen vragen.
*/
      function setupForm(form) {
        if (! form || form.dataset.nrgQuoteReady === 'true') return;
        

        var quoteSelect = form.querySelector('[data-nrg-quote-toggle]');
        var quoteField = form.querySelector('[data-nrg-quote-interest]');
        if (! quoteSelect || ! quoteField) return;
        

        var quoteTextarea = quoteField.querySelector('textarea');
        var channelField = form.querySelector('[data-nrg-sales-channel]');
        var channelSelect = channelField
          ? channelField.querySelector('select')
          : null;
        var bodyLabel = form.querySelector('[data-nrg-body-label]');
        var company = form.querySelector('[data-nrg-company]');
        var quoteOnly = form.querySelectorAll('[data-nrg-quote-only]');

        function update() {
          var wantsQuote = quoteSelect.value === QUOTE_YES;

          if (channelField) 
            channelField.hidden = wantsQuote;
          
          if (channelSelect) 
            channelSelect.disabled = wantsQuote;
          

          quoteField.hidden = ! wantsQuote;
          if (quoteTextarea) {
            quoteTextarea.disabled = ! wantsQuote;
            quoteTextarea.required = wantsQuote;
          }

          if (company) 
            company.required = ! wantsQuote;
          
          quoteOnly.forEach(function(el) {
            el.hidden = ! wantsQuote;
          });

          if (bodyLabel) {
            var label = wantsQuote
              ? bodyLabel.dataset.labelQuote
              : bodyLabel.dataset.labelPartner;
            if (label) 
              bodyLabel.textContent = label;
            
          }
        }

        quoteSelect.addEventListener('change', update);
        update();
        form.dataset.nrgQuoteReady = 'true';
      }

      function initForms(root) {
        (root || document).querySelectorAll('.nrg-retailer-form__form').forEach(setupForm);
      }

      function scrollToEl(el) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.scrollIntoView({
          behavior: reduceMotion
            ? 'auto'
            : 'smooth',
          block: 'center'
        });
      }

/* Zet het formulier in 'partner' of 'offerte' en scroll naar de juiste plek. */
      function openForm(form, mode) {
        if (! form) return false;
        
        setupForm(form);

        var quoteSelect = form.querySelector('[data-nrg-quote-toggle]');
        if (! quoteSelect) return false;
        

        quoteSelect.value = mode === 'quote'
          ? QUOTE_YES
          : QUOTE_NO;
        quoteSelect.dispatchEvent(new Event('change', {bubbles: true}));

        var target = mode === 'quote'
          ? form.querySelector('[data-nrg-quote-interest]')
          : form;
        if (! target) return false;
        
        scrollToEl(target);

        var focusEl = mode === 'quote'
          ? target.querySelector('textarea')
          : form.querySelector('input:not([type="hidden"])');
        if (focusEl) 
          focusEl.focus({preventScroll: true});
        
        return true;
      }

/* Knoppen en kaarten. Zonder JavaScript werkt de gewone ankerlink. */
      document.addEventListener('click', function(event) {
        var trigger = event.target.closest('[data-nrg-form-cta]');
        if (! trigger) return;
        
        var form = document.getElementById(trigger.getAttribute('data-nrg-form-cta'));
        if (openForm(form, trigger.getAttribute('data-nrg-mode') || 'partner')) 
          event.preventDefault();
        
      });

/* Link met ?offerte=ja (bijv. vanaf een productpagina) opent direct de offerte. */
      function openFromUrl() {
        var value = new URLSearchParams(window.location.search).get('offerte');
        if (! value || ['ja', '1', 'true'].indexOf(value.toLowerCase()) === -1) return;
        
        openForm(document.querySelector('.nrg-retailer-form__form'), 'quote');
      }

      function start() {
        initForms(document);
        openFromUrl();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      document.addEventListener('shopify:section:load', function(event) {
        initForms(event.target);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdx-brand-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setState(toggle, playing) {
    var label = toggle.querySelector('[data-rdx-video-toggle-label]');
    var text = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
    toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
    if (label) label.textContent = text;
    toggle.setAttribute('aria-label', text);
  }

  function initVideo(video) {
    if (video.dataset.rdxVideoReady === 'true') return;
    video.dataset.rdxVideoReady = 'true';

    var section = video.closest('.rdx-brand-page');
    var toggle = section ? section.querySelector('[data-rdx-video-toggle]') : null;

    function play() {
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
      if (toggle) setState(toggle, true);
    }

    function pause() {
      video.pause();
      if (toggle) setState(toggle, false);
    }

    if (motionQuery.matches) {
      pause();
    } else {
      play();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          play();
        } else {
          pause();
        }
      });
    }

    motionQuery.addEventListener('change', function (event) {
      if (event.matches) {
        pause();
      } else {
        play();
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.rdx-brand-page__media-video').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepr-brand-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function setToggleState(toggle, playing) {
    if (!toggle) return;
    var text = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
    var label = toggle.querySelector('[data-stepr-video-toggle-label]');
    toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
    toggle.setAttribute('aria-label', text);
    if (label) label.textContent = text;
  }

  function initHeroVideo(video) {
    if (video.dataset.steprReady === 'true') return;
    video.dataset.steprReady = 'true';

    var root = video.closest('[data-stepr-root]');
    var toggle = root ? root.querySelector('[data-stepr-video-toggle]') : null;

    // iOS weigert autoplay tenzij muted en playsInline als PROPERTY gezet zijn;
    // alleen het HTML-attribuut is niet in alle versies genoeg.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');

    // Precies één bron laden, afhankelijk van de viewport.
    function pickSource() {
      var wanted = mobileQuery.matches ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (!wanted || video.dataset.currentSrc === wanted) return false;
      video.dataset.currentSrc = wanted;
      video.src = wanted;
      video.load();
      return true;
    }

    function attemptPlay() {
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Autoplay geblokkeerd (bijv. iOS Low Power Mode of databesparing).
          // Toon de knop als 'speel video' zodat de bezoeker zelf kan starten.
          setToggleState(toggle, false);
        });
      }
    }

    function play() {
      var switched = pickSource();
      if (switched && video.readyState < 2) {
        // Direct na load() is er nog geen data: wachten op canplay, anders
        // faalt play() stil en blijft de video zwart.
        video.addEventListener('canplay', attemptPlay, { once: true });
        return;
      }
      attemptPlay();
    }

    function pause() {
      video.pause();
    }

    // De klassenaam volgt de echte staat van het element, niet onze intentie.
    video.addEventListener('playing', function () {
      video.setAttribute('data-stepr-video-active', '');
      setToggleState(toggle, true);
    });

    video.addEventListener('pause', function () {
      setToggleState(toggle, false);
    });

    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (video.paused) {
          play();
        } else {
          pause();
        }
      });
    }

    if (motionQuery.matches) {
      // Geen beweging: bron alleen laden als de bezoeker zelf op play drukt.
      setToggleState(toggle, false);
    } else {
      play();
    }

    motionQuery.addEventListener('change', function (event) {
      if (event.matches) {
        pause();
      } else {
        play();
      }
    });

    mobileQuery.addEventListener('change', function () {
      if (!video.paused) play();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-stepr-hero-video]').forEach(initHeroVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toorx-professional-brand"] && !Shopify.designMode) return;
  try {
    
/*
 * Films in de Toorx Professional pagina.
 *
 * - preload="none" in de markup: er wordt niets gedownload tot de film in
 *   beeld komt of de bezoeker op de knop drukt. De poster draagt het beeld.
 * - Automatisch starten gebeurt alleen als de sectie dat vraagt EN de
 *   bezoeker geen verminderde beweging heeft ingesteld.
 * - Buiten beeld pauzeert de film weer, zodat er geen bandbreedte weglekt.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setLabel(toggle, playing) {
    var span = toggle.querySelector('[data-txp-video-toggle-label]');
    var label = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
    if (span && label) span.textContent = label;
    toggle.setAttribute('aria-label', label || '');
  }

  function init(stage) {
    if (stage.dataset.txpVideoReady === 'true') return;
    stage.dataset.txpVideoReady = 'true';

    var video = stage.querySelector('video');
    var toggle = stage.querySelector('[data-txp-video-toggle]');
    if (!video || !toggle) return;

    var wantsAutoplay = stage.hasAttribute('data-txp-video-autoplay');
    var userPaused = false;

    video.addEventListener('play', function () { setLabel(toggle, true); });
    video.addEventListener('pause', function () { setLabel(toggle, false); });
    setLabel(toggle, false);

    toggle.addEventListener('click', function () {
      if (video.paused) {
        userPaused = false;
        video.play();
      } else {
        userPaused = true;
        video.pause();
      }
    });

    if (!wantsAutoplay || reduced.matches || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused) {
              var attempt = video.play();
              if (attempt && attempt.catch) attempt.catch(function () {});
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(stage);
  }

  function initAll() {
    document.querySelectorAll('[data-txp-video]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virtual-showroom"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initShowroom = (root) => {
    if (!root || root.dataset.vsReady === 'true') return;
    root.dataset.vsReady = 'true';

    const scenes = Array.from(root.querySelectorAll('[data-vs-scene]'));
    const previousButton = root.querySelector('[data-vs-prev]');
    const nextButton = root.querySelector('[data-vs-next]');
    const counter = root.querySelector('[data-vs-counter]');
    const dialog = root.querySelector('[data-vs-dialog]');
    const dialogContent = root.querySelector('[data-vs-dialog-content]');
    const closeButton = root.querySelector('[data-vs-close]');
    let currentIndex = 0;

    const showScene = (index) => {
      if (!scenes.length) return;
      currentIndex = Math.max(0, Math.min(index, scenes.length - 1));
      scenes.forEach((scene, sceneIndex) => {
        scene.hidden = sceneIndex !== currentIndex;
      });
      if (previousButton) previousButton.disabled = currentIndex === 0;
      if (nextButton) nextButton.disabled = currentIndex === scenes.length - 1;
      if (counter) counter.textContent = `${currentIndex + 1} / ${scenes.length}`;
    };

    const openProduct = (button) => {
      const templateId = button.dataset.templateId;
      const template = templateId ? document.getElementById(templateId) : null;
      if (!template || !dialog || !dialogContent) return;
      dialogContent.replaceChildren(template.content.cloneNode(true));
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeProduct = () => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (dialogContent) dialogContent.replaceChildren();
    };

    root.addEventListener('click', (event) => {
      const hotspot = event.target.closest('[data-vs-hotspot]');
      if (hotspot) {
        openProduct(hotspot);
        return;
      }

      if (event.target.closest('[data-vs-prev]')) {
        showScene(currentIndex - 1);
        return;
      }

      if (event.target.closest('[data-vs-next]')) {
        showScene(currentIndex + 1);
        return;
      }

      if (event.target.closest('[data-vs-close]')) {
        closeProduct();
      }
    });

    if (dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeProduct();
      });
      dialog.addEventListener('cancel', () => {
        if (dialogContent) dialogContent.replaceChildren();
      });
    }

    root.addEventListener('change', (event) => {
      const select = event.target.closest('[data-vs-variant-select]');
      if (!select) return;

      const form = select.closest('.virtual-showroom__product-form');
      const option = select.options[select.selectedIndex];
      const price = form?.closest('.virtual-showroom__product-info')?.querySelector('[data-vs-price]');
      const idInput = form?.querySelector('[data-vs-variant-id]');
      const addButton = form?.querySelector('[data-vs-add-button]');

      if (idInput) idInput.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (addButton) addButton.disabled = option.dataset.available !== 'true';
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('.virtual-showroom__product-form');
      if (!form) return;

      event.preventDefault();
      const idInput = form.querySelector('[data-vs-variant-id]');
      const addButton = form.querySelector('[data-vs-add-button]');
      const message = form.closest('.virtual-showroom__product-info')?.querySelector('[data-vs-message]');
      const variantId = Number(idInput?.value);

      if (!variantId || !addButton) return;

      const originalText = addButton.textContent;
      addButton.disabled = true;
      if (message) message.textContent = '';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.errorText);

        addButton.textContent = root.dataset.addedText;
        if (message) message.textContent = root.dataset.addedText;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        window.setTimeout(() => {
          addButton.textContent = root.dataset.addText || originalText;
          addButton.disabled = false;
        }, 1600);
      } catch (error) {
        if (message) message.textContent = error.message || root.dataset.errorText;
        addButton.textContent = originalText;
        addButton.disabled = false;
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const selected = root.querySelector(`[data-vs-block-id="${event.detail.blockId}"]`);
      if (!selected) return;
      const sceneNumber = selected.dataset.vsBlockScene;
      const sceneIndex = scenes.findIndex((scene) => scene.dataset.sceneNumber === sceneNumber);
      if (sceneIndex >= 0) showScene(sceneIndex);
    });

    if (closeButton) closeButton.disabled = false;
    showScene(0);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-vs-root]').forEach(initShowroom);
  };

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
